import React, {Component} from 'react';
import SettingsRatesList from './list.jsx'
import SettingsRatesForm from './form.jsx'
import SystemMsg from '../../common/system-msg.jsx'
import { Col, Row, Button} from 'react-bootstrap';
import "assets/css/rates.css";
import Select from '../../form/select.jsx'

class SettingsRates extends Component{
  constructor(props){
  	super(props);
    const { user } = this.props.session;
    let permissions = null;

    if (user && user.role && user.role.permissions) {
      user.role.permissions.forEach((area) => {
        if (area.area === 'settings') {
          permissions = area;
        }
      });
    }
  	this.state = {
      levelId: null,
      permissions,
    };
  }

  componentWillMount() {
      this.props.settingsLevelsList()
  }

  componentWillUnmount() {
    this.props.settingsRatesHideForm()
    this.props.settingsRatesShowList()
  }

  render(){
    if (
      !this.state.permissions
      || (
        !this.state.permissions.can_read
        && !this.state.permissions.can_create
        && !this.state.permissions.can_delete
        && !this.state.permissions.can_update
        && !this.state.permissions.limit_to_own_user
      )
    ) {
      if (this.state.permissions) {
        this.props.router.push('/404');
      }
      return null;
    }
    return (
      <section className="rates-content">
        { this.props.settingsRates.inProgress || this.props.settingsLevels.inProgress ? <SystemMsg msg="Loading" hasSpinner /> : '' }
        <div className="box">
          <div className="box-header with-border">
            {this._getTitle()}
          </div>
          <div className="box-content">
            {this.props.settingsRates.showList && this.state.levelId ?<SettingsRatesList levelId={this.state.levelId} {...this.props} />:""}
            {this.props.settingsRates.showForm?<SettingsRatesForm levelId={this.state.levelId} {...this.props} />:""}
          </div>
        </div>



      </section>
    )
  }

  _getTitle(){
    let levels = []

    for(let i = 0; i < this.props.settingsLevels.data.length; i++){
      levels.push(
        {
            name: this.props.settingsLevels.data[i].name,
            value: this.props.settingsLevels.data[i].id
        }
      )
    }
    if(this.props.settingsRates.showList){
      return (
        <Row>
          <Col xs={3} sm={3} md={2} lg={1} className="title-section">
            <h1 className="box-title">Rates</h1>
          </Col>
          <Col  xs={9} sm={6} md={4} lg={3}>
            <Select schema={{
                value: this.state.levelId,
                name: "level",
                label: "",
                disabled: this.props.settingsRates.inProgress || this.props.settingsLevels.inProgress,
                placeholder: "Select a Level to continue",
                options: levels,
                onChange: this._setLevel.bind(this),
                searchable: true
              }} />
          </Col>
          <Col xs={6} sm={3} md={2} lg={2}>
              {(this.state.levelId)?<Button bsSize="small" bsStyle="success"  className="button-new" onClick={this.props.settingsRatesShowForm.bind(this, "newItem")} disabled={this.props.settingsRates.inProgress || this.props.settingsLevels.inProgress}>Add New Rate</Button>:""}
          </Col>
        </Row>



      )
    }else if(this.props.settingsRates.showForm){
      return (
        <div>
          <Row>
            <Col xs={12}>
              <Button bsSize="xsmall" onClick={this.props.settingsRatesShowList.bind(this)}><span className="fa fa-arrow-circle-o-left"></span> Back</Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="title-section">
              <h1 className="box-title">{this.props.settingsRates.itemId?"Edit Rate":"Add New Rate"}</h1>
            </Col>
          </Row>
        </div>


      )
    }
  }

  _setLevel(level){
    this.setState({"levelId": level})
  }
}

export default SettingsRates
